import React from "react";
import $ from "jquery";
import { Button, Spin, Card, } from "antd";
import ConfigGetter from "../utils/ConfigGetter";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import TradingViewChart from "../component/TradingViewChart";

const cnf = ConfigGetter.getConfig();

/**
 * build login page
 */

export default class DashBoard extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            item: "1",
            pageInfo: undefined,
        };
        this.loadDashboard();
    }

    loadDashboard () {
        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/dashboard",
            success: (data) => {
                this.setState({ pageInfo: data });
            },
            error: (data) => {
                console.log("error: " + JSON.stringify(data));
            }
        });
    }

    setStyleByElementId () {
        let item = this.state.item;
        let button1 = document.getElementById("button1");
        let button2 = document.getElementById("button2");
        if (button1 !== null && button2 !== null) {
            if (item === "1") {
                button1.style.backgroundColor = "#FF4D4F";
                button1.style.color = "#F5F5F5";
                button2.style.backgroundColor = "#F5F5F5";
                button2.style.color = "#FF4D4F";
            }
            else {
                button2.style.backgroundColor = "#FF4D4F";
                button2.style.color = "#F5F5F5";
                button1.style.backgroundColor = "#F5F5F5";
                button1.style.color = "#FF4D4F";
            }
        }
    }

    render () {
        return (
            <div>
                <div align="center" style={{ paddingTop: "15px" }}>
                    <Button id={"button1"} type="danger" onClick={() => {
                        this.setState({ item: "1" });
                    }}>
                        <LeftOutlined/>Market
                    </Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button id={"button2"} type="danger" onClick={() => {
                        this.setState({ item: "2" });
                    }}>
                        <RightOutlined/>Channels
                    </Button>
                    {this.setStyleByElementId()}
                </div>
                {this.showContent()}
            </div>
        );
    }

    showContent () {
        let item = this.state.item;
        let pageInfo = this.state.pageInfo;

        if (item === "1") {
            return (
                <div>
                    <div id="view" style={{ height: window.innerHeight * 0.78, padding: "1% 6%", margin: "0" }}>
                        <TradingViewChart/>
                    </div>
                </div>
            );
        }
        else if (item === "2") {
            if (!pageInfo) {
                return (<div style={{ margin: "0 auto", paddingTop: "10%", paddingLeft: "50%", width: "100%" }}><Spin
                    size="large" tip={"Loading"}/></div>);
            }
            return (
                <div>
                    <div style={{ width: "80%", margin: "0 auto" }}>
                        {Object.keys(pageInfo).map((item) => {
                            return (
                                <div key={item} style={{ boxShadow: "3px 3px 20px #DCDCDC", margin: "1% auto" }}>
                                    <Card title={item} bordered={false}>
                                        <div style={{ position: "relative", left: "6%" }}>
                                            {Object.keys(pageInfo[item]).map((page) => {
                                                return (
                                                    <div style={{ cursor: "pointer", margin: "0 auto" }} key={page}
                                                         onClick={() => {
                                                             this.props.history.push(page);
                                                         }}><Card.Grid className={"gridStyle"}
                                                                       key={pageInfo[item][page]}>{pageInfo[item][page]}</Card.Grid>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </Card>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/view/DashBoard.js